import React, { Component } from "react";
import RoadmapMessage from "./RoadmapMessage";
import Diagram from "./Diagram";
import "./css/Roadmap.css";

class RoadMap extends Component {

    render() {
        return (
            <>
                <div className="roadmap-wrapper">
                    <div className="container">
                        <RoadmapMessage />
                    </div>
                    <Diagram />
                </div>
            </>
        );
    }
}

export default RoadMap;